import { styled, } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';


export const ExpertButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 14,
  padding: '6px 12px',
  border: '1px solid var(--light_color_shade)',
  backgroundColor: 'var(--light_color_shade)',
  borderColor: 'var(--light_color_shade)',
  color: '#fff',
  fontFamily: [
    'Poppins,Lato,sans-serif'
  ].join(','),
  '&:hover': {
    backgroundColor: '#fff',
    borderColor: 'var(--light_color_shade)',
    color: 'var(--light_color_shade)',
  },
  '&:disabled': {
    opacity: '0.55',
    color: '#fff',
    cursor: 'not-allowed'
  },
});
